import '../../core/styles/focusRingStatic.css';
import './ExpandableText.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var expandableTextButtonCSS = '_19jh2ut3-3-8-0 _z0fq9b4-3-8-0 _z0fq9bd-3-8-0 _z0fq9b5-3-8-0 _z0fq9bb-3-8-0';
export var expandableTextCSS = _7a468({defaultClassName:'_19jh2ut0-3-8-0',variantClassNames:{expanded:{true:'_19jh2ut1-3-8-0',false:'_19jh2ut2-3-8-0'}},defaultVariants:{},compoundVariants:[]});